import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class MiscFunctionsService {
    public base64Encode(str :string) {
        console.log(`MiscFunctionsService.base64Encode - str = ${str}`);
        try {
            console.log(`MiscFunctionsService.base64Encode - Try #1 - str = ${str}`);
            return btoa(str);
        } catch {
            try {
                console.log(`MiscFunctionsService.base64Encode - Try #2 - str = ${unescape(decodeURIComponent(str))}`);
                return btoa(unescape(decodeURIComponent(str)));
            } catch {
                console.log(`MiscFunctionsService.base64Encode - Try #3 - str = ${str.replace(/[\u00A0-\u2666]/g, function(c: any) {
                    return '&#' + c.charCodeAt(0) + ';';
                })}`);

                return btoa(str.replace(/[\u00A0-\u2666]/g, function(c) {
                    return '&#' + c.charCodeAt(0) + ';';
                }));
            }
        }
    }

    public getDateMediumShort = (utcDate: string): string | null => {
        if (utcDate !== undefined && utcDate !== null) {
            if (!utcDate.endsWith('Z')) {
                utcDate = `${utcDate}Z`;
            }
            const date = new Date(utcDate);
            return formatDate(date, 'MMM dd, yyyy h:mm a', 'en-US');
        } else {
            return null;
        }
    }
    public getDateMedium = (utcDate: string): string | null => {

        if (utcDate !== undefined && utcDate !== null) {
            if (!utcDate.endsWith('Z')) {
                utcDate = `${utcDate}Z`;
            }
            const date = new Date(utcDate);
            return formatDate(date, 'medium', 'en-US');
        } else {
            return null;
        }
    }
    public getExpiration=(utcDate: string) : any => {

        if (utcDate != undefined && utcDate !== null) {
            if (!utcDate.endsWith('Z')) {
                utcDate = `${utcDate}Z`;
            }

            console.log(new Date().toUTCString());
            let diffInMs = new Date(utcDate).getTime() - new Date().getTime();
            //var diffInMs = Date.parse(utcDate) - Date.parse(new Date().toString());
            
            console.log(diffInMs);
            return this.parseMillisecondsIntoReadableTime(diffInMs);
        }
    }
    private parseMillisecondsIntoReadableTime =(milliseconds: number) => {
        //Get hours from milliseconds
        let hours = milliseconds / (1000 * 60 * 60);
        let absoluteHours = Math.floor(hours);
        let   h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

        //Get remainder from hours and convert to minutes
        let minutes = (hours - absoluteHours) * 60;
        let absoluteMinutes = Math.floor(minutes);
        let m = absoluteMinutes > 9 ? absoluteMinutes : '0' + absoluteMinutes;
        //Get remainder from minutes and convert to seconds
        let seconds = (minutes - absoluteMinutes) * 60;
        let absoluteSeconds = Math.floor(seconds);
        let s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

        if (milliseconds <= 0) {
            return '00 minutes';
        } else if (Number(h) >= 1) {
            return h + ' hours ' + m + ' minutes ';
        } else if (Number(h) < 1 && Number(m) >= 0) {
            return m + ' minutes';
        }
        return null;
    }
}
